module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/ian_sara_lean_smile-12d488cb6a6d1d48a6f2c910bc4b245d.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/ian_sara_lean_smile.png
// module id = 2376
// module chunks = 2